/**
 * Adapts commercial contact information received from backend to be displayed in the EmptyState component.
 * @param {Object|null} comercialInfo - Object received from backend with assigned executive data.
 * @param {Function} t - Translation function, usually provided by i18next.
 * @returns {{ name: string, email: string, phone: string }} - Adapted data for frontend display.
 */
const adaptComercialInfo = (comercialInfo = {}, t = () => {}) => {
  const email = comercialInfo.owner_email;
  const phone = comercialInfo.owner_phone;

  const hasContactInfo = !!email || !!phone;

  return {
    name: hasContactInfo
      ? comercialInfo.owner_name || t('professionalPubli.publish.emptyState.defaultName')
      : t('professionalPubli.publish.emptyState.defaultName'),
    email: hasContactInfo ? email || '' : t('professionalPubli.publish.emptyState.defaultMail'),
    phone: hasContactInfo ? phone || '' : t('professionalPubli.publish.emptyState.defaultPhone'),
    hasContactInfo: hasContactInfo
  };
};
export default adaptComercialInfo;
